import { useState, useEffect, useRef } from 'react';

import { usePostHog } from 'posthog-js/react';

import { parse } from 'papaparse';

import { db } from "../firebase";
import { doc, updateDoc, onSnapshot, collection, getDocs, deleteDoc, setDoc, arrayUnion, addDoc } from "firebase/firestore";

import { Play, Circle, Pause, Square, ChevronRight, X, SquareArrowOutUpRight, ChevronDown, Plus, Upload, ArrowRight } from 'lucide-react';

import ContactCard from './ContactCard';

const Lists = ({ myLists, selectedList, setSelectedList, uid, setMyLists, setCallbacks, setUpcoming }) => {

  const posthog = usePostHog();

  const [callQueue, setCallQueue] = useState(() => {
    return Number(localStorage.getItem("CREEL_DIALER_CURRENT_QUEUE")) || 0;
  });
  const queuedNum = useRef(null);

  const [callEnded, setCallEnded] = useState(false);
  const [queueEnded, setQueueEnded] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [contactsImmutable, setContactsImmutable] = useState([]);
  const [dialing, setdialing] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showNewList, setShowNewList] = useState(false);
  const [selectedContact, setSelectedContact] = useState({});
  const [showDateInput, setShowDateInput] = useState(false);
  const [showMapping, setShowMapping] = useState(false);
  const [uploadedListFields, setUploadedListFields] = useState([]);
  const [listToMap, setListToMap] = useState([]);
  const [showEditContact, setShowEditContact] = useState(false);

  const endQueue = async () => {
    if (!queueEnded) {
      if (!dialing) {
        setCallQueue(0);
      }
      setQueueEnded(true);
      setdialing(false);
      posthog?.capture('stopped-dialing', { user_id: uid });
    } else {
      console.log("Queue already ended");
    }
  }

  const handleStartPause = async () => {
    if (!dialing) {
      setQueueEnded(false);
      window.location.assign("zoomphonecall:" + contacts[callQueue].phone);
    }
    setdialing(!dialing);
  }

  const handleSubmitNote = async (e) => {
    e.preventDefault();

    const note = e.target.note.value;
    const status = e.target.status.value;
    const name = e.target.name.value;
    const title = e.target.title.value;
    const email = e.target.email.value;
    const company = e.target.company.value;
    const url = e.target.url.value;

    const contactDocRef = doc(db, "autodialer", "users", "ids", uid, "lists", selectedList, "contacts", contacts[callQueue - 1].id);
    if (e.target.doNotCall.checked === true) {
      const permission = window.confirm("Are you sure you want to delete this contact? This action cannot be undone.");
      if (permission) {
        await deleteDoc(contactDocRef);
      }
      if (dialing) {
        window.location.assign("zoomphonecall:" + contacts[callQueue].phone);
      }
      if (queueEnded) {
        setCallQueue(0);
      }
    } else if (e.target.callBack.checked === true) {
      const dueDate = new Date(e.target.dueDate.value);
      const now = new Date();
      const killMe = new Date(dueDate);
      const timeDelta = killMe.getTime() - now.getTime();

      if (timeDelta < 0) {
        alert('You cannot select a date in the past.');
        return;
      }

      await deleteDoc(contactDocRef);
      const updatedNotes = [...contacts[callQueue].notes];
      updatedNotes.push({ noteDate: new Date(), noteText: note, status: status });
      const callBackDocRef = doc(db, "autodialer", "users", "ids", uid, "callbacks", contacts[callQueue - 1].id);
      const callbackDocData = {
        phone: contacts[callQueue - 1].phone,
        name: name,
        title: title,
        email: email,
        notes: updatedNotes,
        company: company,
        url: url,
        dueDate: dueDate
      }
      await setDoc(callBackDocRef, callbackDocData);
      posthog?.capture('callback-saved', { user_id: uid });
      callbackDocData.dueDate = { seconds: Math.floor(new Date(dueDate).getTime() / 1000) };
      callbackDocData.notes[callbackDocData.notes.length - 1].noteDate = { seconds: Math.floor(new Date().getTime() / 1000) };
      const eightHours = 8 * 60 * 60 * 1000;
      if (timeDelta < eightHours) {
        setCallbacks(prev => [...prev, callbackDocData]);
      } else {
        setUpcoming(prev => [...prev, callbackDocData]);
      }
      if (dialing) {
        window.location.assign("zoomphonecall:" + contacts[callQueue].phone);
      }
      if (queueEnded) {
        setCallQueue(0);
      }
    } else {
      await updateDoc(contactDocRef, {
        name: name,
        title: title,
        company: company,
        email: email,
        url: url,
        notes: arrayUnion({ noteDate: new Date(), noteText: note, status: status }),
        lastContact: new Date(),
      });
      posthog?.capture('note-saved', { user_id: uid });
      const contactsTmp = [...contacts];
      contactsTmp[callQueue - 1].name = name;
      contactsTmp[callQueue - 1].title = title;
      contactsTmp[callQueue - 1].email = email;
      contactsTmp[callQueue - 1].company = company;
      contactsTmp[callQueue - 1].url = url;
      contactsTmp[callQueue - 1].notes.push({ noteDate: { seconds: Math.floor(new Date().getTime() / 1000) }, noteText: note, status: status });

      setContacts(contactsTmp);

      if (dialing) {
        window.location.assign("zoomphonecall:" + contacts[callQueue].phone);
      }
      if (queueEnded) {
        setCallQueue(0);
      }
    }
    setShowDateInput(false);
    setCallEnded(false);
  }

  const handleSelectContact = (id) => {
    const quereyResult = contacts.find(contact => contact.id === id);
    setSelectedContact(quereyResult);
    setShowContact(true)
  }

  const uploadListToDb = async (listName, list) => {
    const listsColRef = collection(db, "autodialer", "users", "ids", uid, "lists");
    const newListDoc = await addDoc(listsColRef, {
      listName: listName,
    });
    posthog?.capture('uploaded-list', { user_id: uid, list_name: listName });

    const myListsTmp = [...myLists, { id: newListDoc.id, listName: listName }];
    setMyLists(myListsTmp);

    list.forEach((contact) => {
      const contactsColRef = collection(db, "autodialer", "users", "ids", uid, "lists", newListDoc.id, "contacts");
      addDoc(contactsColRef, {
        ...contact,
        lastContact: "",
        notes: [],
      });
    });
    setSelectedList(newListDoc.id);
  }

  const handleNewList = (e) => {
    e.preventDefault();
    const file = e.target.list.files[0];
    const listName = e.target.listName.value;
    if (listName !== '') {
      parse(file, {
        skipEmptyLines: 'greedy',
        header: true,
        complete: async function (results) {
          const parsedList = results.data;
          const csvFields = Object.keys(parsedList[0]);
          const requiredFields = ["company", "email", "name", "phone", "title", "url"];
          const templateMatch = [...csvFields].sort().join() === [...requiredFields].sort().join();
          if (templateMatch) {
            // Proceed
            uploadListToDb(listName, parsedList);
            e.target.reset();
            setShowNewList(false);
          } else {
            // Start mapping flow
            setListToMap(parsedList);
            setUploadedListFields(csvFields);
            setShowMapping(true);
          }
        }
      });
    } else {
      alert('Please enter a name for your list.');
    }
  }

  const handleNewMappedList = async (e) => {
    e.preventDefault();
    const listName = e.target.listName.value;
    const mappedList = listToMap.map((contact) => {
      return ({
        company: contact[document.getElementById('company').value],
        name: contact[document.getElementById('name').value],
        title: contact[document.getElementById('title').value],
        phone: contact[document.getElementById('phone').value],
        email: contact[document.getElementById('email').value],
      })
    });
    uploadListToDb(listName, mappedList);
    e.target.reset();
    setShowMapping(false);
    setShowNewList(false);
  }

  const handleEditContact = async (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    const title = e.target.title.value;
    const company = e.target.company.value;
    const phone = e.target.phone.value;
    const email = e.target.email.value;
    const url = e.target.url.value;
    const contactDocRef = doc(db, 'autodialer', 'users', 'ids', uid, 'lists', selectedList, 'contacts', selectedContact.id);
    await updateDoc(contactDocRef, {
      name,
      title,
      company,
      phone,
      email,
      url,
    });
    setContacts(prev => {
      const i = prev.findIndex(contact => contact.id === selectedContact.id);
      const next = [...prev];
      next[i].name = name;
      next[i].title = title;
      next[i].company = company;
      next[i].phone = phone;
      next[i].email = email;
      return next;
    });
    setShowEditContact(false);
    setShowContact(true);
  }

  const handleFilterByStatus = (e) => {
    e.preventDefault();
    const selectedStatus = e.target.value;
    posthog?.capture('filtered-by-status', { user_id: uid, status: selectedStatus });
    if (selectedStatus === 'all') {
      setContacts(contactsImmutable);
    } else {
      setContacts(() => {
        const next = [...contactsImmutable].filter((contact) => {
          return (contact.notes[contact.notes.length - 1]?.status === selectedStatus.replace(" ", "-"));
        });
        return next;
      });
    }
  }

  useEffect(() => {
    if (contacts.length > 0) {
      try {
        queuedNum.current = contacts[callQueue].phone;
      } catch { }
    }
    localStorage.setItem("CREEL_DIALER_CURRENT_QUEUE", callQueue);
  }, [callQueue, contacts]);

  useEffect(() => {
    const fetchContacts = async () => {
      const contactsColRef = collection(db, "autodialer", "users", "ids", uid, "lists", selectedList, "contacts");
      const contactsSnapshot = await getDocs(contactsColRef);
      const contactsTmp = [];
      contactsSnapshot.forEach((doc) => {
        contactsTmp.push({
          ...doc.data(),
          id: doc.id
        });
      });
      setContactsImmutable(contactsTmp);
      setContacts(contactsTmp);
    }
    fetchContacts();
  }, [uid, selectedList]);


  useEffect(() => {
    const docRef = doc(db, "autodialer", "users", "ids", uid);
    const unsub = onSnapshot(docRef, (doc) => {
      console.log("Listening for zoom events...");
      const docData = doc.data();
      const event = docData.zoomEvents.event;
      if (event === "phone.caller_ended") {
        let calleeNum;
        let queuedNumClean;
        try {
          calleeNum = docData.zoomEvents.payload.object.callee.phone_number;
          queuedNumClean = '+1' + queuedNum.current.replace(/[-\s()]/g, '');
        } catch {
          console.log('Captured event from call not in queue.');
        }
        if (calleeNum === queuedNumClean) {
          setCallEnded(true);
          setCallQueue(prev => prev + 1);
          posthog?.capture('call-ended', { user_id: uid, phone_number: calleeNum });
        }
        updateDoc(docRef, { zoomEvents: {} });
      }
    });
    return () => unsub();
  }, [uid]);

  return (
    <div className='page-wrapper'>
      <div className='list-controls'>
        <div className='list-selector-wrapper'>
          <button className='new-list-btn' onClick={() => setShowNewList(true)}>
            <Plus size={"1.6rem"} />
          </button>
          <select className='list-selector' name='list' value={selectedList} onChange={(e) => setSelectedList(e.target.value)}>
            {myLists.map((list) => {
              return (
                <option value={list.id} key={list.id}>{list.listName}</option>
              )
            })
            }
          </select>
          <div className='list-selector-icon'>
            <ChevronDown size={'1.6rem'} />
          </div>
        </div>
        <div className='start-stop-wrapper'>
          <button
            className='start-pause-btn'
            onClick={() => handleStartPause()}
          >
            {
              !dialing ?
                <Play size={'1.8rem'} fill={'var(--neutral-600)'} />
                :
                <Pause size={'1.8rem'} fill={'var(--neutral-600)'} />
            }
          </button>
          <button
            className='start-pause-btn stop'
            onClick={() => endQueue()}
          >
            <Square size={'1.4rem'} fill={'var(--neutral-600)'} />
          </button>
        </div>
      </div>
      <div className='status-bar'>
        <div className='status'>
          <Circle size={'0.7rem'} fill={queueEnded ? 'var(--ui-red)' : dialing ? 'var(--ui-green)' : 'var(--neutral-400)'} color={'none'} />
          <div className={dialing ? "status-animation" : null}>{queueEnded ? "Finished" : dialing ? "Active" : "Standby"}</div>
          <div>{callQueue + 1} / {contacts.length}</div>
        </div>
        <div className='filters-wrapper'>
          Status
          <select className='small' onChange={(e) => handleFilterByStatus(e)}>
            <option>all</option>
            <option>interested</option>
            <option>warm</option>
            <option>cold</option>
            <option>left message</option>
            <option>no answer</option>
            <option>not interested</option>
            <option>reschedule</option>
          </select>
        </div>
      </div>
      <ul className='queue'>
        {
          contacts.map((contact, index) => {
            return (
              <li className={index < callQueue ? "number called" : "number"} key={contact.id}>
                {
                  index === callQueue &&
                  <div className="queue-cursor">
                    <ChevronRight size={'1.8rem'} fill='var(--neutral-400)' />
                  </div>
                }
                <div>
                  <button className='set-queue-position-btn' title='Start queue here' onClick={() => { setCallQueue(index); posthog?.capture('set-queue-position-manually', { user_id: uid, position: index }) }}>
                    <ChevronRight size={'1.8rem'} fill='var(--accent-1)' />
                  </button>
                  {contact.phone}
                </div>
                <div className={!contact.name ? "missing" : null} title={contact.name}>
                  <button className='open-contact-btn' onClick={() => handleSelectContact(contact.id)}>
                    <SquareArrowOutUpRight size={'1.2rem'} />
                  </button>
                  {contact.name || "(Name)"}
                </div>
                <div title={contact.company}>{contact.company || "(Company)"}</div>
              </li>
            )
          })
        }
      </ul>
      {callEnded &&
        <div className='lightbox'>
          <div className='lightbox-header'>
            Call notes
            <button className='close-btn' onClick={() => { setCallEnded(false); setdialing(false) }}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <form className='call-notes' onSubmit={(e) => handleSubmitNote(e)}>
              <div className='input-group'>
                <label>
                  Contact name
                  <input type="text" name="name" placeholder='John' defaultValue={contacts[callQueue - 1].name} />
                </label>
                <label>
                  Title
                  <input type="text" name="title" placeholder='Manager' defaultValue={contacts[callQueue - 1].title} />
                </label>
              </div>
              <label>
                Company
                <input type="text" name="company" placeholder='Acme Inc' defaultValue={contacts[callQueue - 1].company} />
              </label>
              <label>
                Website
                <input type="text" name="url" placeholder='Acme Inc' defaultValue={selectedContact.url} />
              </label>
              <label>
                Email
                <input type="text" name="email" placeholder='john@acme.com' defaultValue={contacts[callQueue - 1].email} />
              </label>
              <label>
                Call status
                <select name="status">
                  {
                    ["", "interested", "warm", "cold", "left-message", "no-answer", "not-interested", "reschedule"].map((status) => {
                      return (
                        <option value={status} key={status}>{status.replace("-", " ")}</option>
                      )
                    })
                  }
                </select>
              </label>
              <label className='checkbox-wrapper' >
                <input type="checkbox" name="callBack" onChange={() => setShowDateInput(prev => !prev)} /> Callback
              </label>
              {showDateInput && <input type="datetime-local" name="dueDate" />}
              <label className='checkbox-wrapper'>
                <input type="checkbox" name="doNotCall" /> Don't call
              </label>
              <label htmlFor="note">
                Note
                <textarea name="note" rows={3} placeholder='Brief description of the call...' />
              </label>
              <button className='main-btn'>
                Next
                <ChevronRight className='btn-chevron' size={"1.6rem"} />
              </button>
            </form>
          </div>
        </div>
      }
      {
        showContact &&
        <div className='lightbox'>
          <div className='lightbox-header'>
            Contact card
            <button className='close-btn' onClick={() => setShowContact(false)}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <ContactCard
              selectedContact={selectedContact}
              selectedList={selectedList}
              uid={uid}
              setContacts={setContacts}
              setShowContact={setShowContact}
              setShowEditContact={setShowEditContact}
              menu={true}
            />
          </div>
        </div>
      }
      {
        showNewList &&
        < div className='lightbox'>
          <div className='lightbox-header'>
            New list
            <button className='close-btn' onClick={() => { setShowNewList(false); setShowMapping(false) }}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <form className='new-list-form' onSubmit={(e) => showMapping ? handleNewMappedList(e) : handleNewList(e)}>
              <label>
                <div>List name<span style={{ color: 'var(--ui-red)' }}>*</span></div>
                <input type='text' placeholder='Campaign leads' name='listName' />
              </label>
              {!showMapping ?
                <div className='upload-block'>
                  <input type='file' accept='.csv' name='list' />
                  <Upload size={"1.6rem"} />
                </div>
                :
                <div className='mapping-form'>
                  <label>List mapping</label>
                  {
                    ["Name", "Company", "Title", "Phone", "Email", "URL"].map((requiredField) => {
                      return (
                        <label>
                          <select id={requiredField.toLowerCase()}>
                            <option value=''>Select</option>
                            {
                              uploadedListFields.map((field) => {
                                return (
                                  <option value={field} key={field}>{field}</option>
                                )
                              })
                            }
                          </select>
                          <ArrowRight size={"1.2rem"} color={'var(--neutral-400)'} />
                          <div>{requiredField}</div>
                        </label>
                      )
                    })
                  }
                </div>
              }
              <div>Download the <a href='https://smartdial-files.netlify.app/template.csv' download='template.csv'>CSV template</a></div>
              <button className='main-btn'>Upload</button>
            </form>
          </div>
        </div>
      }
      {
        showEditContact &&
        <div className='lightbox'>
          <div className='lightbox-header'>
            Edit contact
            <button className='close-btn' onClick={() => setShowEditContact(false)}>
              <X size={'1.2rem'} />
            </button>
          </div>
          <div className='lightbox-modal'>
            <form className='call-notes' onSubmit={(e) => handleEditContact(e)}>
              <div className='input-group'>
                <label>
                  Contact name
                  <input type="text" name="name" placeholder='John' defaultValue={selectedContact.name} />
                </label>
                <label>
                  Title
                  <input type="text" name="title" placeholder='Manager' defaultValue={selectedContact.title} />
                </label>
              </div>
              <label>
                Company
                <input type="text" name="company" placeholder='Acme Inc' defaultValue={selectedContact.company} />
              </label>
              <label>
                Website
                <input type="text" name="url" placeholder='Acme Inc' defaultValue={selectedContact.url} />
              </label>
              <label>
                Phone
                <input type="text" name="phone" placeholder='(555)-123-4567' defaultValue={selectedContact.phone} />
              </label>
              <label>
                Email
                <input type="text" name="email" placeholder='john@acme.com' defaultValue={selectedContact.email} />
              </label>
              <button className='main-btn'>
                Save
              </button>
            </form>
          </div>
        </div>
      }
    </div >
  );
}

export default Lists;